<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <div class="d-flex">
              <strong class="align-self-center">Equipes</strong>
              <a
                v-permission="'Equipe.Adicionar'"
                class="ml-auto btn btn-primary"
                href="/#/equipe/novo"
                title="Adicionar nova equipe"
              >
                Adicionar
              </a>
            </div>
          </header>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                <div class="form-group">
                  <label for>Buscar</label>
                  <div class="d-flex">
                    <input
                      v-model="term"
                      class="form-control"
                      type="text"
                      placeholder="Digite o nome da equipe"
                      @keyup.enter="ObterGrid(1)"
                    />
                    <button
                      class="btn btn-secondary ml-2"
                      type="button"
                      title="Filtrar"
                      @click="ObterGrid(1)"
                    >
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="loading" class="loading-container">
              <RotateSquare
                class="loading-position animated fadeIn"
                size="60px"
              ></RotateSquare>
            </div>
            <div v-else>
              <b-table
                :hover="true"
                responsive
                :items="itens"
                :fields="fields"
                striped
                :per-page="itensPorPagina"
                show-empty
                empty-text="Nenhuma equipe encontrada."
              >
                <template v-slot:empty="scope">
                  <h4>{{ scope.emptyText }}</h4>
                </template>
                <template v-slot:cell(active)="data">
                  <div class="center">
                    <span v-if="data.item.active" class="badge badge-success">
                      Sim
                    </span>
                    <span v-else class="badge badge-secondary">Não</span>
                  </div>
                </template>
                <template v-slot:cell(acoes)="data">
                  <div class="btn-group-sm">
                    <b-button
                      variant="warning"
                      style="margin-right: 10px"
                      title="Editar"
                      @click="Editar(data.item)"
                    >
                      <i class="fa fa-edit"></i>
                    </b-button>
                    <b-button
                      variant="danger"
                      title="Remover"
                      v-permission="'Equipe.Remover'"
                      @click="Remover(data.item)"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
              <b-pagination
                v-model="pagina"
                :total-rows="total"
                :per-page="itensPorPagina"
                align="right"
                size="md"
                class="mt-2"
              ></b-pagination>
            </div>
            <b-modal
              v-model="modalRemover"
              title="Confirmar exclusão"
              class="modal-danger"
              ok-variant="danger"
              @ok="ModalOk"
              @hidden="ModalCancel"
            >
              Você confirma a exclusão dessa equipe?
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import TeamService from "../../servico/TeamService";
import ApiError from "../../util/ApiError";

export default {
  name: "Team",
  components: {
    RotateSquare
  },
  data() {
    return {
      modalRemover: false,
      itemRemover: null,
      loading: false,
      term: "",
      itens: [],
      pagina: 1,
      total: 0,
      itensPorPagina: 20,
      fields: [
        { key: "name", label: "Nome", sortable: true },
        { key: "membersCount", label: "Membros", sortable: true },
        { key: "active", label: "Ativa", sortable: true },
        {
          key: "acoes",
          label: "Ações",
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ]
    };
  },
  watch: {
    pagina: function (val) {
      this.ObterGrid(val);
    }
  },
  beforeMount() {
    this.ObterGrid(1);
  },
  methods: {
    Editar(equipe) {
      this.$router.push("/equipe/editar/" + equipe.id);
    },
    ModalCancel(evento) {
      evento.preventDefault();
      this.itemRemover = null;
    },
    ModalOk(evento) {
      evento.preventDefault();
      this.modalRemover = false;
      if (!this.itemRemover) return;

      TeamService.Remove(this.itemRemover.id)
        .then(() => {
          this.itemRemover = null;
          this.ObterGrid(1);
          this.$notify({
            data: ["Equipe removida com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.itemRemover = null;
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    },
    Remover(item) {
      this.modalRemover = true;
      this.itemRemover = item;
    },
    ObterGrid(pagina) {
      this.loading = true;

      TeamService.GetGrid(pagina, this.term)
        .then((response) => {
          this.loading = false;
          this.itens = response.data.itens;
          this.total = response.data.total;
          this.pagina = response.data.pagina;
          this.itensPorPagina = response.data.itensPorPagina;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: ApiError.Messages(erro),
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>
